module.exports = __webpack_public_path__ + "static/media/b41@2x.1a9c84fb.png";